import HeroText from "../../components/heros/hero-text";
import ContactsCards from "./components/contacts-cards/contacts-cards";
import ContactsFindUs from "./components/contacts-find-us/contacts-find-us";
import ContactsMap from "./components/contacts-map/contacts-map";
import ContactReady from "./components/contacts-ready/contacts-ready";

const Contacts: React.FC = () => {
  return (
    <div className="contacts">
      <HeroText
        title="Contatti"
        text="Siamo qui per rispondere alle tue domande e supportarti nei tuoi progetti"
      />
      <ContactsCards />
      <ContactsFindUs />
      <ContactsMap />
      <ContactReady />
    </div>
  );
};
export default Contacts;
